module.exports = __webpack_public_path__ + "media/images/logo-onabet-c3f82717.svg";